import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  Stack,
  Chip,
  ListItemText,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import FormHelperText from '@mui/material/FormHelperText';

import { Controller } from "react-hook-form"

import { useState } from "react";

import {useFormContext} from 'react-hook-form';

const listLabel = (value,list) => {
    return list.filter((cur) => {
        return value === cur.value;
    })[0]?.label || value;
};

const FormMultiSelectChips = ({
  name,
  enableSelectAll,
  label,
  list,
  required,
  rules = {},
}) => {
  const [selectAll, setSelectAll] = useState(false);
  const [noOptionsSelected, setNoOptionsSelected] = useState(false)
  const { control, formState, setValue } = useFormContext();

  const errors = formState.errors

  const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
  rules = { ...requiredDefaultRule, ...rules };

  const labelId = name + "-label";

  return (
    <Controller
      render={({ field: { onChange, value, onBlur } }) => {
        value = value || [];
        return (
          <FormControl fullWidth error={errors[name] ? true : false}>
            <InputLabel id={labelId} required={required}>
              {label}
            </InputLabel>
            <Select
              multiple
              labelId={labelId}
              onBlur={onBlur}
              value={value || []}
              onChange={(e) => {
                setNoOptionsSelected(false);
                if(e.target.value.includes('All')){
                  if (!selectAll) {
                    const allValues = list.map((cur) => cur.value);
                    onChange(allValues);
                  } else {
                    onChange([]);
                  }
                  setSelectAll(!selectAll);
                }
                else{
                  if(e.target.value.includes('All')){
                    onChange([]);
                    setSelectAll(!selectAll);
                  }
                  if (enableSelectAll && e.target.value.length === list.length) {
                    setSelectAll(true);
                  }

                  onChange(e.target.value);
                }
              }}
              input={<OutlinedInput label={label} />}
              renderValue={(selected) => (
                <Stack gap={1} direction="row" flexWrap="wrap">
                  {selected.map((cur) => (
                    <Chip
                      key={cur}
                      label={listLabel(cur, list)}
                      onDelete={() =>{
                        setNoOptionsSelected(false);
                        setValue(
                          name,
                          value.filter((item) => item !== cur)
                          )
                        }
                      }
                      deleteIcon={
                        <CancelIcon
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      }
                    />
                  ))}
                </Stack>
              )}
            >
              {enableSelectAll && (
                <MenuItem  key={'All'}
                value={'All'} 
                disabled={noOptionsSelected}
                >
                  <ListItemText
                    primary={value.length===list.length?"Unselect All":"Select all"}
                  />
                </MenuItem>
              )}
              {list.map((cur) => (
                <MenuItem
                  disabled={noOptionsSelected}
                  key={cur.value}
                  value={cur.value}
                  sx={{ justifyContent: "space-between" }}
                >
                  {cur.label}
                  {value.includes(cur.value) ? <CheckIcon color="info" /> : null}
                </MenuItem>
              ))}
            </Select>
            {errors[name] && (
              <FormHelperText><Typography component="span">{errors[name]?.message?.toString()}</Typography></FormHelperText>
            )}
          </FormControl>
        );
      }}
      name={name}
      control={control}
      rules={rules}
    />
  );
}
export default FormMultiSelectChips;
